import Api from './Indicadores'
export default {
    getByStage(id){
        return Api().get("/period/stage/"+id);
    },
    getById(id){
        return Api().get("/period/"+id);
    },
    createperiod(data){
        return Api().post("/period/create",data);
    },
    updateperiod(data){
        return Api().post("/period/update",data);
    },
    deleteperiod(id){
        return Api().delete("/period/delete/"+id);
    },

    getSectorConfig(periodId, sectorId, cancelToken) {
        if(cancelToken){
            return Api().get(`/period/sector-config/status/${periodId}/${sectorId}`, {
                cancelToken: cancelToken.token
            });
        }
        return Api().get(`/period/sector-config/status/${periodId}/${sectorId}`);
    },
    
    // Uma linha por perspectiva do ciclo: valor efetivo (active*), valor gravado no
    // próprio setor (ownActive*, null = herda) e se a perspectiva está bloqueada.
    getPerspectiveMatrix(periodId, sectorId, cancelToken) {
        if(cancelToken){
            return Api().get(`/period/sector-config/matrix/${periodId}/${sectorId}`, {
                cancelToken: cancelToken.token
            });
        }
        return Api().get(`/period/sector-config/matrix/${periodId}/${sectorId}`);
    },

    saveSectorConfig(config) {
        return Api().post("/period/sector-config/save", config);
    },
    
    syncSectorConfig(periodId, sectorId, forceValues) {
        return Api().post(`/period/sector-config/sync/${periodId}/${sectorId}`, forceValues);
    },
    
    getDefaultPeriodForSector(sectorId) {
        return Api().get(`/period/sector-config/default/${sectorId}`);
    },
    
    setDefaultPeriod(periodId, sectorId) {
        return Api().post(`/period/sector-config/set-default/${periodId}/${sectorId}`);
    },
    
    getPeriodConfigurations(periodId) {
        return Api().get(`/period/sector-config/all/${periodId}`);
    },

    kpiEnable(id){
        return Api().post("/period/kpi-enable/"+id+"/1")
    },
    kpiDisable(id){
        return Api().post("/period/kpi-enable/"+id+"/0")
    },
    setCurrent(id){
        return Api().post("/period/set/default/"+id)
    },
    getByMaster(id){
        return Api().get('/period/master/'+id)
    },
    getByMasterAndStage(id, stage){
        return Api().get('/period/master/'+id+ '/'+ stage)
    },
    changeProperty(id, tipo, entidad){
        let prop = 'enable';
        if(tipo === 'active'){
            prop = entidad.active ? 'enable' : 'disable';
        }if(tipo === 'controller'){
            prop = entidad.controllerEnable ? 'enable' : 'disable';
        }if(tipo === 'evaluator'){
            prop = entidad.evaluatorEnable ? 'enable' : 'disable';
        }if(tipo === 'manager'){
            prop = entidad.managerEnable ? 'enable' : 'disable';
        }
        return Api().post('/period/' +prop+ '/' + id + '/' + tipo)
    },
    periodSave(periodForm){
        return Api().post('/period/save', periodForm);
    },
    getCurrentPeriod() {
        return Api().get("/period/current");
    },
}

export function buildExplicitFlags(model) {
  // Devuelve solo las claves con boolean explícito (true/false)
  const out = {};
  ['activeEmployee','activeManager','activeController','activeAuditor','isDefault'].forEach(k => {
    if (model[k] === true || model[k] === false) out[k] = model[k];
  });
  return out;
}

export function buildUnsetFields(model) {
  // Devuelve lista de claves cuyo valor deseado es "heredar" (null)
  const out = [];
  ['activeEmployee','activeManager','activeController','activeAuditor','isDefault'].forEach(k => {
    if (model[k] === null) out.push(k);
  });
  return out;
}